
export const datosGeneralesModel = {
    idDatosGeneralesRI: 0,
    edadAnio: 0,
    edadMeses: 0,
    centroReferencia: false,
    codInstitucionReferencia: '',
    idComboRIValorLugarServicio: 0,
    idComboRIValorLugarRI: 0,
    servicioEmergencia: '',
    telefonoEmergencia: '',
    resumenHCL: '',
    diagnosticoAlta: '',
    enfermedadOncologica: false,
    otrosAntecedentes: '',
    comentarioRelevante: '',
    otrasAlergias: '',
    medicacionHabitual: '',
    estableHemodinamicamente: '',
    estableEnfermedad: '',
    nivelConciencia: '',
    escaras: '',
    ostomias: '',
    otrosRelevantes: '',
    pesoActual: 0,
    talla: 0,
    idComboRIValorNivelActividad: 0,
    idComboRIValorAduPerdidaPeso: 0,
    aduPesoHabitual: 0,
    aduIMC: 0,
    aduPerdidaPeso: 0,
    idComboRIValorAduEvaluado: 0,
    idComboRIValorAduGradoDesnutricion: 0,
    idComboRIValorAduDiagnosticoNutricional: 0,
    idComboRIValorAduMetaNutricional: 0,
    pedCircunferenciaMBraquial: 0,
    pedZScoreTalla: 0,
    pedZScorePeso: 0,
    pedZScoreIMC: 0,
    idComboRIValorPedDiagnosticoNutricional: 0,
    idComboRIValorPedMetaSoporteNutricional: 0,
    direccion: '',
    familiarContacto: '',
    telContacto: '',
    nAfiliado: '',
    diagnosticosRI: [],
    alergias: [],
    antecedentesClinicos: [],
    requerimientosExtraNutricionalesRI: [],
    justificacionSoporteRI: []
};